function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
  requiredExtensions: "&ns_ai;",
  x: 0,
  y: 0,
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("iPgfRef", {
  xlinkHref: "#adobe_illustrator_pgf"
})), /*#__PURE__*/React.createElement("g", {
  iExtraneous: "self"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeMiterlimit: 10,
  d: "M13,0.5C6.1,0.5,0.5,6.1,0.5,13c0,6.9,5.6,12.5,12.5,12.5 S25.5,19.9,25.5,13C25.6,6.1,19.9,0.5,13,0.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M11.6,6.9c0-0.1,0-0.3-0.1-0.4c0-0.2,0-0.3,0-0.4c0-0.1,0-0.2,0-0.4c0-0.1,0-0.3,0.1-0.4 c0.2,0,0.3,0,0.5,0c0.2,0,0.4,0,0.5,0c0.1,0,0.3,0,0.4,0s0.3,0,0.4,0c0,0.1,0,0.2,0.1,0.4c0,0.1,0,0.3,0,0.4s0,0.3,0,0.4 c0,0.2,0,0.3-0.1,0.4c-0.1,0-0.3,0-0.4,0s-0.3,0-0.4,0c-0.2,0-0.3,0-0.5,0S11.7,7,11.6,6.9 M12.3,10.8h-1.4c0,0,0-0.1-0.1-0.2 c0-0.1,0-0.2,0-0.3s0-0.2,0-0.3c0-0.1,0-0.2,0.1-0.3h2.8v10.9c-0.1,0-0.2,0-0.4,0c-0.2,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.4,0 c-0.2,0-0.3,0-0.4,0L12.3,10.8L12.3,10.8z"
}))));

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlnsxX: "&ns_extend;",
    xmlnsI: "&ns_ai;",
    xmlnsGraph: "&ns_graphs;",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    enableBackground: "new 0 0 26 26",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.bda3fe8d.svg";
export { ForwardRef as ReactComponent };